var map = {
	".": "8T7x",
	"./": "8T7x",
	"./auditLog": "VtY8",
	"./auditLog.json": "VtY8",
	"./backup": "7ZDH",
	"./backup.json": "7ZDH",
	"./blogCategory": "1Z8w",
	"./blogCategory.json": "1Z8w",
	"./blogPost": "Piuv",
	"./blogPost.json": "Piuv",
	"./caseStudy": "N61T",
	"./caseStudy.json": "N61T",
	"./common": "RUMV",
	"./common.json": "RUMV",
	"./configuration": "kEFh",
	"./configuration.json": "kEFh",
	"./contact": "qJzs",
	"./contact.json": "qJzs",
	"./crud": "GwX5",
	"./crud.json": "GwX5",
	"./dashboard": "KG4b",
	"./dashboard.json": "KG4b",
	"./footer": "Bz0f",
	"./footer.json": "Bz0f",
	"./forgot": "5nY4",
	"./forgot.json": "5nY4",
	"./header": "6wrV",
	"./header.json": "6wrV",
	"./index": "8T7x",
	"./index.js": "8T7x",
	"./login": "XngJ",
	"./login.json": "XngJ",
	"./pageConfiguration": "0tPw",
	"./pageConfiguration.json": "0tPw",
	"./payment": "VqX5",
	"./payment.json": "VqX5",
	"./pdfTemplate": "soL+",
	"./pdfTemplate.json": "soL+",
	"./permission": "2jNJ",
	"./permission.json": "2jNJ",
	"./resetPassword": "h4xQ",
	"./resetPassword.json": "h4xQ",
	"./role": "5fHP",
	"./role.json": "5fHP",
	"./sample": "jlXd",
	"./sample.json": "jlXd",
	"./sider": "smyv",
	"./sider.json": "smyv",
	"./signUp": "y4oA",
	"./signUp.json": "y4oA",
	"./sms": "kmus",
	"./sms.json": "kmus",
	"./staticPage": "oHBx",
	"./staticPage.json": "oHBx",
	"./support": "oFut",
	"./support.json": "oFut",
	"./systemPage": "qiGN",
	"./systemPage.json": "qiGN",
	"./template": "7feM",
	"./template.json": "7feM",
	"./theme": "Wy44",
	"./theme.json": "Wy44",
	"./user": "f+qO",
	"./user.json": "f+qO",
	"./verification": "iBY1",
	"./verification.json": "iBY1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NtX3";